import React, {useState,useEffect} from 'react';
import _ from 'lodash'
import * as bootstrap from 'bootstrap';

import $ from "jquery";

import { DataGrid } from '@mui/x-data-grid';
import QuickSearchToolbar from '../components/MUI-QuickSearchToolBar';
import CustomPagination from '../components/MUI-DGPagination';
import apiService from '../services/api';

// const getData = async (folder,name) =>{
//     return await fetch('data/'+folder+name+'.json')
//     .then(response => response.json())
//     .then(data => {return data});
// }

// function Loading(){
//     return(
//         <div className="h-100 d-flex justify-content-center">
//             <div className="align-self-center">
//                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>{loading}
//             </div>
//         </div>
//     )
// }

function Users(props){
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [objData, setObjData] = useState({});

    const fetchData = async () => {
        try {
            setLoading(true);
            setError(null);
            // Lấy danh sách staff
            const response = await apiService.getStaff();
            console.log('Staff API response:', response);
            
            // Format data để phù hợp với DataGrid
            const formattedData = response.data.map((staff, index) => {
                console.log('Processing staff:', staff);
                return {
                    id: staff._id || index,
                    _id: staff._id,
                    displayName: staff.displayName || staff.name, // Ưu tiên displayName từ API
                    email: staff.email,
                    device: staff.device || staff.staffId, // Ưu tiên device từ API
                    code: staff.code || staff.phone || staff.pinCode || getRandomCode(),
   
                };
            });
            
            console.log('Formatted data:', formattedData);
            setData(formattedData);
        } catch (err) {
            console.error('Error fetching staff data:', err);
            setError('Lỗi khi tải dữ liệu nhân viên');
        } finally {
            setLoading(false);
        }
    };

    useEffect(()=>{
        fetchData();
    },[]);

    const columns = [
        { field: 'displayName', headerName: 'Nhân viên',    headerAlign: 'center', flex: 1},
        { field: 'email',       headerName: 'Email',        headerAlign: 'center', flex: 1},
        { field: 'device',      headerName: 'Tên thiết bị',     headerAlign: 'center', flex: 0.5,   align: "center"},
        { field: 'code',        headerName: 'Mã PIN',       headerAlign: 'center', flex: 0.5,   align: "center"},
        // {
        //   field: 'fullName',
        //   headerName: 'Full name',
        //   description: 'This column has a value getter and is not sortable.',
        //   sortable: false,
        //   width: 160,
        //   valueGetter: (params) =>
        //     `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        // },
    ];

    const getRandomCode = () => {
        return (Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000).toString();
    };

    async function handleAddUser(e){
        e.preventDefault();
        try {
            var tmp = {};
            for(var i = 0; i < e.target.length-2; i++){
                tmp[`${e.target[i].id}`] = e.target[i].value;
            }
            
            // Map form fields to API format with new schema
            const staffData = {
                displayName: tmp.displayName || '',
                email: tmp.email || '',
                device: tmp.device || getRandomCode(),
                code: tmp.code || getRandomCode()
            };

            console.log('Adding staff:', staffData);
            const response = await apiService.createStaff(staffData);
            console.log('Staff added:', response);
            
            // Reload data
            await fetchData();
            // Đóng modal
            const modal = bootstrap.Modal.getInstance(document.getElementById('addUserModal'));
            if (modal) modal.hide();
            // Reset form
            e.target.reset();
        } catch (err) {
            console.error('Error adding staff:', err);
            alert('Lỗi khi thêm nhân viên: ' + err.message);
        }
    }

    async function handleUpdateUser(e){
        e.preventDefault();
        try {
            if(!objData._id) {
                alert('Vui lòng chọn nhân viên để cập nhật');
                return;
            }
            
            if(objData.code==="") objData.code = getRandomCode();
            
            // Map objData to API format
            const updateData = {
                displayName: objData.displayName,
                email: objData.email,
                device: objData.device,
                code: objData.code,
            };
            
            console.log('Updating staff with ID:', objData._id, 'Data:', updateData);
            const response = await apiService.updateStaff(objData._id, updateData);
            console.log('Staff updated:', response);
            
            // Reload data
            await fetchData();
            // Đóng modal
            const modal = bootstrap.Modal.getInstance(document.getElementById('updateUserModal'));
            if (modal) modal.hide();
            // Reset selection
            setSelected([]);
            setObjData({});
        } catch (err) {
            console.error('Error updating staff:', err);
            alert('Lỗi khi cập nhật nhân viên: ' + err.message);
        }
    }

    async function handleDelUser(e){
        e.preventDefault();
        try {
            if(selected.length === 0) {
                alert('Vui lòng chọn nhân viên để xóa');
                return;
            }
            
            // Lấy danh sách _id để xóa
            const idsToDelete = selected.map(id => {
                const item = data.find(dt => dt.id === id);
                return item ? item._id : null;
            }).filter(id => id !== null); // Loại bỏ các giá trị null
            
            if(idsToDelete.length === 0) {
                alert('Không tìm thấy nhân viên để xóa');
                return;
            }
            
            console.log('Deleting staff with IDs:', idsToDelete);
            const response = await apiService.deleteStaff({ _id: { $in: idsToDelete } });
            console.log('Staff deleted:', response);
            
            // Reload data
            await fetchData();
            // Đóng modal
            const modal = bootstrap.Modal.getInstance(document.getElementById('deleteUserModal'));
            if (modal) modal.hide();
            // Reset selection
            setSelected([]);
            setObjData({});
        } catch (err) {
            console.error('Error deleting staff:', err);
            alert('Lỗi khi xóa nhân viên: ' + err.message);
        }
    }

    const handleChange = (e)=>{
        console.log('Selection changed:', e);
        console.log('Available data:', data);
        
        $(document).ready(function(){
            setSelected(e);
            
            // Tìm theo id thay vì _id vì DataGrid sử dụng id
            const selectedItem = data.find(dt => dt.id === e[0]);
            console.log('Selected item:', selectedItem);
            
            setObjData(selectedItem || {});
            
            if(_.isEmpty(e)){
                $('#updateButton').addClass("Mui-disabled");
                $('#deleteButton').addClass("Mui-disabled");
            }else{
                if(e.length === 1){
                    $('#updateButton').removeClass("Mui-disabled");
                    $('#updateButton').removeAttr("disabled");
                }else{
                    $('#updateButton').addClass("Mui-disabled");
                }
                $('#deleteButton').removeClass("Mui-disabled");
                $('#deleteButton').removeAttr("disabled");
            }
        });
    }

    return(
        <>
            {loading ? (
                <div style={{minHeight: "100vh"}} className="main d-flex align-items-center justify-content-center">
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-2">Đang tải dữ liệu nhân viên...</p>
                    </div>
                </div>
            ) : error ? (
                <div style={{minHeight: "100vh"}} className="main d-flex align-items-center justify-content-center">
                    <div className="text-center">
                        <div className="alert alert-danger" role="alert">
                            {error}
                        </div>
                        <button 
                            className="btn btn-primary" 
                            onClick={() => fetchData()}
                        >
                            Thử lại
                        </button>
                    </div>
                </div>
            ) : (
            <div style={{minHeight: "100vh"}} className="main d-flex align-items-center justify-content-center">
                <div className="container p-3 shadow rounded">
                    <h3 className="pt-2 pb-2">DANH SÁCH NHÂN VIÊN</h3>
                    <div style={{height: "690px", width: "100%"}}>
                        <DataGrid
                            rows={data}
                            columns={columns}
                            pageSize={10}
                            checkboxSelection
                            getRowId={(row) => row.id}
                            onSelectionModelChange={handleChange}
                            disableSelectionOnClick
                            components={{
                                Toolbar: QuickSearchToolbar,
                                Pagination: CustomPagination,
                            }}
                            componentsProps={{
                                toolbar: { 
                                    idAddModal: "#addUserModal",
                                    idUpdateModal: "#updateUserModal",
                                    idDeleteModal: "#deleteUserModal"
                                },
                            }}
                            initialState={{
                                sorting: {
                                    sortModel: [{ field: 'createAt', sort: 'desc' }],
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
            )}
            <div className="modal fade" id="addUserModal" tabIndex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addUserModalLabel">THÊM NHÂN VIÊN</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleAddUser}>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="displayName" placeholder="Tên hiển thị" required/>
                                    <label htmlFor="displayName">Tên hiển thị</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="email" className="form-control" id="email" placeholder="Email" required />
                                    <label htmlFor="email">Email</label>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" className="form-control" id="device" placeholder="Thiết bị" />
                                            <label htmlFor="device">Tên thiết bị</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" className="form-control" id="code" placeholder="Mã PIN" />
                                            <label htmlFor="code">Mã PIN</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn btn-secondary me-2" data-bs-dismiss="modal">Hủy</button>
                                    <button type="submit" className="btn btn-primary">Thêm</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="updateUserModal" tabIndex="-1" aria-labelledby="updateUserModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="updateUserModalLabel">CẬP NHẬT THÔNG TIN NHÂN VIÊN</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleUpdateUser}>
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="displayName" placeholder="Tên hiển thị" onChange={(e) => setObjData({...objData, displayName: e.target.value})} value={objData.displayName || ''} required/>
                                    <label htmlFor="displayName">Tên hiển thị</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input type="email" className="form-control" id="email" placeholder="Email" onChange={(e) => setObjData({...objData, email: e.target.value})} value={objData.email || ''} required/>
                                    <label htmlFor="email">Email</label>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" className="form-control" id="device" placeholder="Thiết bị" onChange={(e) => setObjData({...objData, device: e.target.value})} value={objData.device || ''}/>
                                            <label htmlFor="device">Tên thiết bị</label>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating mb-3">
                                            <input type="text" className="form-control" id="code" placeholder="Mã PIN" onChange={(e) => setObjData({...objData, code: e.target.value})} value={objData.code || ''}/>
                                            <label htmlFor="code">Mã PIN</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-end">
                                    <button type="button" className="btn btn-secondary me-2" data-bs-dismiss="modal">Hủy</button>
                                    <button type="submit" className="btn btn-primary">Sửa</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="deleteUserModal" tabIndex="-1" aria-labelledby="deleteUserModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteUserModalLabel">Xác nhận</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <h2 className="mb-4">Bạn thực sự muốn xóa ?</h2>
                            <div className="d-flex justify-content-center">
                                <button type="button" className="btn btn-secondary me-2 w-100" data-bs-dismiss="modal">Hủy</button>
                                <button type="button" className="btn btn-primary w-100" onClick={handleDelUser}>Xóa</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );    
}
export default Users;